var _ = require('underscore');
var Base = require('front/components/Base/Base');

var template = require('./TopNavDesktop.jinja');
require('./TopNavDesktop.less');

module.exports = Base.extend({

    template: template,

    events: {
        'focus .TopNavDesktop-searchInput': 'onInputFocus',
        'blur .TopNavDesktop-searchInput': 'onInputBlur',
        'keydown .TopNavDesktop-searchInput': 'onInputKeyDown',

        'input .TopNavDesktop-searchInput': 'onInputInput',

        'mouseenter .TopNavDesktop-searchInput': 'onInputMouseEnter',
        'mouseleave .TopNavDesktop-searchInput': 'onInputMouseLeave',

        'click .TopNavDesktop-sidebarListItem--logout': 'onLogoutClick'

//        'click .TopNavDesktop-sidebarList > li > a': 'toggleSubCategory'
    },


    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);
    },


    onInputMouseEnter: function () {
        this.$('.TopNavDesktop-searchIcon').addClass('TopNavDesktop-searchIcon--hovered');
    },


    onInputMouseLeave: function () {
        this.$('.TopNavDesktop-searchIcon').removeClass('TopNavDesktop-searchIcon--hovered');
    },


    onLogoutClick: function () {
        window.app.vent.trigger('make-logout');
    },


    // toggleSubCategory: function (e) {
    //     var $category = $(e.currentTarget);
    //     var $prevSubCategory = this.$prevSubCategory;
    //     var $subCategory = $category.parent().find('.TopNavDesktop-sidebarListNested');

    //     if ($subCategory.length == 0) return;

    //     if ($(e.target).closest('.TopNavDesktop-sidebarListNested').length) return;

    //     e.preventDefault();

    //     if (this.$prevSubCategory) {
    //         this.$prevSubCategory.slideUp(150);
    //         delete this.$prevSubCategory;
    //     }

    //     if ($subCategory.is($prevSubCategory)) return;

    //     $subCategory.slideDown(150);

    //     this.$prevSubCategory = $subCategory;
    // },


    showSearch: function () {
        this.$('.TopNavDesktop-searchBtn').addClass('TopNavDesktop-searchBtn--opened');
        this.searchShown = true;
    },


    hideSearch: function () {
        this.$('.TopNavDesktop-searchBtn').removeClass('TopNavDesktop-searchBtn--opened');

        this.$('.TopNavDesktop-searchInput').val('');

        if (this.$('.TopNavDesktop-searchInput').is(':focus')) {
            app.settings.isDesktop && app.utils.getFocusBack();
        }

        clearTimeout(this.tipTimeout);
        this.$('.TopNavDesktop-search-tip').removeClass('TopNavDesktop-search-tip--show');

        this.searchShown = false;
    },


    onInputFocus: function () {
        this.showSearch();
    },


    onInputBlur: function () {
        this.hideSearch();
    },


    onInputKeyDown: function (e) {
        var $input = $(e.currentTarget);
        var query = $.trim($input.val());

        if (e.keyCode == 13 && query.length > 2) { //enter
            Backbone.history.navigate(app.composeSearchUrl(query, 1, 'all'), {trigger: 'true'});
            this.hideSearch();
            this.tipWasShownOnce = true;
        }

        if (e.keyCode == 27) { //esc
            this.hideSearch();
        }
    },


    onInputInput: function (e) {
        var $input = $(e.currentTarget);
        var query = $.trim($input.val());
        var $tip = this.$('.TopNavDesktop-search-tip');
        var tipClass = 'TopNavDesktop-search-tip--show';
        var isShown = !!query && !this.tipWasShownOnce;

        clearTimeout(this.tipTimeout);

        this.tipTimeout = setTimeout(function () {
            $tip.toggleClass(tipClass, isShown);
        }.bind(this), isShown ? 1000 : 0);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/TopNav/TopNavDesktop.js
// module id = 249
// module chunks = 0